/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GPCComp } from './GPCComp';
import type { PTComp } from './PTComp';
export type PreviousCompGroup = {
  readonly id?: number;
  group_type: PreviousCompGroup.group_type;
  gpc_comps?: Array<GPCComp>;
  pt_comps?: Array<PTComp>;
  readonly version_number?: number;
  readonly created_at?: string;
  readonly updated_at?: string;
  name: string;
  is_deleted?: boolean | null;
  readonly deleted_at?: string | null;
  is_global: boolean;
  latest_version?: number | null;
  firm?: number | null;
  readonly valuation_approach_gpcs?: Array<number>;
  readonly valuation_approach_gpts?: Array<number>;
};
export namespace PreviousCompGroup {
  export enum group_type {
    PRIVATE_TRANSACTIONS = 'Private Transactions',
    PUBLIC_COMPS = 'Public Comps',
  }
}
